import { AxiosResponse } from 'axios'
import { Moment } from 'moment'
import { IGenericEntityResponse } from 'services/core/entityResponseCore'
import { IPaginatedResponse } from 'services/core/paginatedResponseCore'
import { RequestREAD } from 'services/Instances'

export const ChecklistServices = () => {
  const path = 'CheckList'

  const getFilter = async (
    params: ISearchFilter
  ): Promise<
    AxiosResponse<
      IGenericEntityResponse<IPaginatedResponse<IChecklistFilterResponse>>
    >
  > => await RequestREAD.get(`${path}/Filter`, { params })

  return { getFilter }
}

export interface IChecklistFilterResponse {
  idContrato: number
  idMovDocumentoItem: number
  comDocumento: boolean
  cdDocumento: string
  cdContrato: string
  nmFornecedor: string
  dsTipoPendencia: string
  competencia: string
  dtAnexado: string | null
  qtDias: number
}

export interface ISearchFilter {
  comDocumento?: boolean
  CdContrato?: number | string
  idRolDocumento?: number
  NmFornecedor?: string
  IdTipoPendencia?: number
  DtCompetenciaIni?: string | Date | Moment
  DtCompetenciaFim?: string | Date | Moment
  DtAnexadoIni?: string | Date | Moment
  DtAnexadoFim?: string | Date | Moment
  PageNumber: number
  PageSize: number
}
